exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-02724ec1]{width:50%;margin:auto;padding:30px 0}label[data-v-02724ec1]{margin-top:20px}h1[data-v-02724ec1]{letter-spacing:.7px;color:#45be45;margin:20px 0;text-align:center;text-transform:uppercase}.btn-secondary[data-v-02724ec1]{transition:all .3s}@media screen and (max-width:768px){div[data-v-02724ec1]{width:95%}h1[data-v-02724ec1]{font-size:24px}}img[data-v-02724ec1]{display:block;margin:auto;border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02724ec1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Signup.vue
// module id = 702
// module chunks = 0